import { controlComparator as controlComparatorNew } from 'Helpers/Compare';

import { ControlFramework, ControlGroup, ControlText, OperationalControl } from './OperationalControls';

export interface ControlFrameworkHierarchy extends ControlFramework {
    control_groups: ControlGroupHierarchy[];
}

export interface ControlGroupHierarchy extends ControlGroup {
    controls: OperationalControl[];
}

export interface SortableFramework {
    control_framework: string;
    is_custom: boolean;
    control_groups: SortableControlGroup[];
}

export interface SortableControlGroup {
    control_group_id: string;
    control_group_name: string;
    is_custom: boolean;
    controls?: SortableControl[]; // Controls are not part of the TPRM Control Group response object. They are retrieved independently.
}

export interface SortableControl {
    control_id: string;
    control_text: ControlText[];
    is_custom: boolean;
}

export const sortControlHierarchy = (controlHierarchy: ControlFrameworkHierarchy[]): void => {
    for (let framework = 0; framework < controlHierarchy.length; framework++) {
        sortControlGroups(controlHierarchy[framework].control_groups);
    }

    controlHierarchy.sort((frameworkA, frameworkB) => {
        if (frameworkA.is_custom === true && frameworkB.is_custom === false) {
            return 1;
        } else if (frameworkA.is_custom === false && frameworkB.is_custom === true) {
            return -1;
        } else {
            return frameworkA.control_framework.localeCompare(frameworkB.control_framework, undefined, { numeric: true, sensitivity: 'base' });
        }
    });
};

const sortControlGroups = (controlGroups: ControlGroupHierarchy[]): void => {
    for (let i = 0; i < controlGroups.length; i++) {
        if (controlGroups[i].controls) controlGroups[i].controls!.sort(controlComparatorNew);
    }

    controlGroups.sort((controlGroupA, controlGroupB) => {
        if (controlGroupA.is_custom === true && controlGroupB.is_custom === false) {
            return 1;
        } else if (controlGroupA.is_custom === false && controlGroupB.is_custom === true) {
            return -1;
        } else if (controlGroupA.is_custom === false && controlGroupB.is_custom === false) {
            return controlGroupA.control_group_id.localeCompare(controlGroupB.control_group_id, undefined, { numeric: true, sensitivity: 'base' });
        } else {
            if (controlGroupA.control_group_name && controlGroupB.control_group_name) {
                return controlGroupA.control_group_name.localeCompare(controlGroupB.control_group_name, undefined, { numeric: true, sensitivity: 'base' });
            } else if (controlGroupA.control_group_name && !controlGroupB.control_group_name) {
                return 1;
            } else if (!controlGroupA.control_group_name && controlGroupB.control_group_name) {
                return -1;
            } else {
                return 0;
            }
        }
    });
};
